import EliteService from "@/elite-lib-yt/service/EliteService";

export default class BaseService extends EliteService {
    constructor(props) {
        super(props);
    }

    delete(url, body) {
        return () => fetch(url, {
            method: "DELETE",
            body: JSON.stringify(body),
            headers: {
                'Content-Type': 'application/json',
                'ef-client-type': 'web',
                'authorization': this._getAuth() //localStorage.getItem('token')
            }
        })
    }

    post(url, body) {
        return () => fetch(url, {
            method: "POST",
            body: JSON.stringify(body),
            headers: {
                'Content-Type': 'application/json',
                'ef-client-type': 'web',
                'authorization': this._getAuth() //localStorage.getItem('token')
            }
        })
    }

    put(url, body) {
        return () => fetch(url, {
            method: "PUT",
            body: JSON.stringify(body),
            headers: {
                'Content-Type': 'application/json',
                'ef-client-type': 'web',
                'authorization': this._getAuth() //localStorage.getItem('token')
            }
        })
    }

    get(url) {
        return () => fetch(url, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
                'ef-client-type': 'web',
                'authorization': this._getAuth() //localStorage.getItem('token')
            }
        })
    }

    async httpRequest(requestFun) {
        let data = await requestFun();
        if (data.status === 200) {
            return data.json();
        } else if (data.status === 401) {
            await this._refreshToken({ "status": 401 });
            data = await requestFun();
            if (data.status === 200) {
                return data.json();
            } else {
                return Promise.reject(data);
            }
        } else {
            return Promise.reject(data);
        }
    }

    static getQueryString(params) {
        if (params == null) {
            return '';
        }
        return Object.keys(params)
            .map(key => `${key}=${params[key]}`)
            .join('&');
    }
}